<script setup lang="ts">
import type { SlugHeaderContentProps } from '.';

const props = defineProps<SlugHeaderContentProps>();
</script>

<template>
  <SlugHeaderContentDesktop v-bind="props" />
  <SlugHeaderContentMobile v-bind="props" />
</template>
